export default "__VITE_ASSET__B7dvmJ9V__"